export const AzureApplicationIdTooltip = () => (
  <>Application (client) ID from Bayer AzureAD.</>
);
